import { ROLEURL } from "helpers/constant";
import { callApi } from "Apis";
import { MODULEURL } from "helpers/constant";

// Role List Api...
export async function roleList(data) {
  try {
    const response = await callApi({ url: ROLEURL.LIST, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}
// Role Add Api...
export async function addRole(data) {
  try {
    const response = await callApi({ url: ROLEURL.ADD, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}
//Get Role By ID...
export async function getRole(id) {
  try {
    const response = await callApi({ url: ROLEURL.GET(id), method: "GET" });
    return response;
  } catch (err) {
    throw err;
  }
}

// Member Role Api...
export async function deleteRole(id) {
  try {
    const response = await callApi({
      url: ROLEURL.DELETE(id),
      method: "DELETE",
    });
    return response;
  } catch (err) {
    throw err;
  }
}

//Update Role Api...

export async function updateRole(data) {
  try {
    const response = await callApi({ url: ROLEURL.UPDATE, body: data, method: "PUT" });
    return response;
  } catch (err) {
    throw err;
  }
}

//Get module list...

export async function getModuleListApi(data) {
  try {
    const response = await callApi({ url: MODULEURL.LIST, body: data, method: "GET" });
    return response;
  } catch (err) {
    throw err;
  }
}
